var React = require('react');

function Sparkles (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M14 26a6.083 6.083 0 0 0 5-5 6.083 6.083 0 0 0 5 5 6.083 6.083 0 0 0-5 5 6.083 6.083 0 0 0-5-5zM0 15a8.516 8.516 0 0 0 7-7 8.516 8.516 0 0 0 7 7 8.516 8.516 0 0 0-7 7 8.516 8.516 0 0 0-7-7zM15 6a7.3 7.3 0 0 0 6-6 7.3 7.3 0 0 0 6 6 7.3 7.3 0 0 0-6 6 7.3 7.3 0 0 0-6-6z"})));
}

Sparkles.defaultProps = {"width":"27","height":"31","viewBox":"0 0 27 31"};

module.exports = Sparkles;

Sparkles.default = Sparkles;
